import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

const Caption = props => {
  if (!(props.category || props.series || props.isSponsored)) {
    return null;
  }

  const hasCaption = !!(props.category || props.series);
  // Always use these two under the truthy condition of hasCaption
  const capLink = props.series ? `/${_.get(props, 'series.slug')}` : `/categories/${_.get(props, 'category.slug')}`;
  const capTitle = _.get(props, props.series ? 'series.title' : 'category.name');

  return (
    <h5 className="caption">
      {hasCaption && (
        <span className="main">
          <a href={capLink} data-event-type="click" data-event="link_click">{capTitle}</a>
        </span>
      )}
      {!!(hasCaption && props.isSponsored) && <span className="separator">•</span>}
      {!!props.isSponsored && (
        <span className="secondary">sponsored</span>
      )}
    </h5>
  );
};

Caption.propTypes = {
  isSponsored: PropTypes.bool.isRequired,
  category: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string,
  }),
  series: PropTypes.shape({
    slug: PropTypes.string,
    title: PropTypes.string,
  }),
};

Caption.defaultProps = {
  category: null,
  series: null,
};

const Wire = props => (
  <li>
    <Caption {...props} />
    <h3>
      <a
        href={`/wires/${props.slug}`}
        data-statisticable-event="click"
        data-statisticable-type="wire"
        data-statisticable-id={props.id}
      >
        {props.title}
      </a>
    </h3>
    <div className="byline">
      <a className="author" href={`/contributors/${props.profile.slug}`}>{props.profile.name}</a>
      <span className="organization">{props.profile.organization}</span>
    </div>
  </li>
);

Wire.propTypes = {
  slug: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    organization: PropTypes.string,
  }).isRequired,
};

export default function TrendingPanel(props) {
  const { trending, classNames } = props;

  return (
    <div className={classNames}>
      <h2>
        <span>
          {'TRENDING '}
          <b>ON LIVEWIRE</b>
        </span>
      </h2>
      <ul>
        {_.map(trending, wire => <Wire key={wire.slug} {...wire} />)}
      </ul>
      <p className="trending-view-all">
        <a href="/feeds/trending" className="link-primary">View All</a>
      </p>
    </div>
  );
}

TrendingPanel.propTypes = {
  trending: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
  })).isRequired,
  classNames: PropTypes.string.isRequired,
};
